<nz-spin [nzSpinning]="loading">
  <div class="wmsm-box">
    <div class="条件区">
      <app-wmsm-WHQRtconditions [show]="true" [Showagree]="false" [showSave]="false" [Showreject]="false" [ShowSecondDown]="false" [ShowBuyer]="true"  [ShowVendor]="true" [ShowTime]="false" [ShowPONO]="true"  [ShowNotInvoice]="false"  [ShowApplyDept]="false" [ShowInvoiceNo]="false"  [ShowPANO]="false" [ShowBillingStatus]="false" [ShowSend]="false" [Query]="false" (listenForm)="getFormValue($event)" [WHQKey]="onQueryClick1()"></app-wmsm-WHQRtconditions>
    </div>
    <form nz-form [formGroup]="validateForm">
    <!-- <div nz-row>
      <div nz-col nzSpan="8">
        <nz-form-item>
          <nz-form-label nzSpan="8">
            <div class="width-100-percent label-font">{{ "table.PONO" | translate}}
            </div>
          </nz-form-label>
          <nz-form-control nzSpan="16">
            <input nz-input formControlName="PONO" />
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSpan="5" class="width-100-percent" style="left: 28px">
        <button nz-button class="default-button" nzType="primary" (click)="onSearch()">{{ "Query" | translate}}</button>
      </div>
    </div> -->
  </form>
    <div class="信息区" style="float: right"></div>

    <nz-card>
    <div >
      <strong class="margin-left-8 result">{{ "Results" | translate}}({{nzTotal}})</strong>
    </div>
    <div class="表格">
      <nz-table #colSpanTable [nzData]="listOfData" style="margin-bottom: 10px" nzSize="middle" nzShowSizeChanger 
        [nzFrontPagination]="false" [nzShowPagination]='false' [nzPageSize]='pageSize' [nzPageIndex]='pageIndex'
        [nzScroll]="{ y: '600px',x:'1500px' }">
        <thead>
          <tr >
            <th scope="col" nzWidth="40px" style="text-align:center;">{{ "PendingDays" | translate}}</th>
            <th scope="col" nzWidth="80px" [nzSortFn]="true" (nzSortOrderChange)="sortChange($event)" style="text-align:center;">{{ "PoNo" | translate}}</th>
            <th scope="col" nzWidth="65px" [nzSortFn]="true" (nzSortOrderChange)="sortChange1($event)" style="text-align:center;">{{ "InvoiceNo" | translate}}</th>
            <th scope="col" nzWidth="65px" style="text-align:center;">{{ "InvoiceDate" | translate}}</th>
            <th scope="col" nzWidth="50px" style="text-align:center;">{{ "table.WHQCurrency" | translate}}</th>
            <th scope="col" nzWidth="60px" style="text-align:center;">{{ "InvoiceAmountBeforeTax" | translate}}</th>
            <th scope="col" nzWidth="50px" style="text-align:center;">{{ "Taxes" | translate}}</th>
            <th scope="col" nzWidth="65px" style="text-align:center;">{{ "table.Buyer" | translate}}</th>
            <th scope="col" nzWidth="100px"style="text-align:center;">{{ "ReasonsForReturningTheDevice" | translate}}</th>
            <th scope="col" nzWidth="50px" style="text-align:center;">{{ "ReturnDate" | translate}}</th>
            <th scope="col" nzWidth="50px" style="text-align:center;">{{ "ExceptionType" | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of colSpanTable.data;let i=index">
            <td style="text-align:center;">
              <div *ngIf="data.pendingDays>='3'" >
                <nz-tag [nzColor]="'red'">{{data.pendingDays}}</nz-tag>
              </div>
              <div *ngIf="data.pendingDays=='0' || data.pendingDays=='1' || data.pendingDays=='2'"   >
                <nz-tag [nzColor]="'green'">{{data.pendingDays}}</nz-tag>
              </div>
            </td>
            <td>{{data.poNo}}</td>
            <td>{{data.invoiceNo}}</td>
            <td>{{data.invoiceDate}}</td>
            <td>{{data.currency}}</td>
            <td style="text-align: right; word-break:break-all;">{{data.amount | number: '1.2-2' }}</td>
            <td style="text-align: right; word-break:break-all;">{{data.taxes | number: '1.2-2' }}</td>
            <td>{{data.buyerName}}</td>
            <td>{{data.buyerRemark}}</td>
            <td>{{data.returnDate}}</td>
            <td>
              <div *ngIf="data.status=='FEInvoice'" >{{ "ElectronicInvoiceAnomaly" | translate}}
              </div>
              <div *ngIf="data.status=='Reject'">{{ "FailPassTheAudit" | translate}}
              </div>
            </td>
          </tr>
        </tbody>
      </nz-table>
      <nz-pagination style="float:right;" [(nzPageIndex)]="pageIndex" [nzTotal]="nzTotal" [nzSize]="'small'"
        nzShowSizeChanger [nzPageSizeOptions]="[10, 20, 50,100]" [nzPageSize]='pageSize'
        (nzPageSizeChange)="nzPageSizeChange($event)"  (nzPageIndexChange)="nzPageIndexChange($event)">
      </nz-pagination>
      <ng-template #renderItemTemplate let-type let-page="page">
         
        <a *ngIf="type === 'page'">{{ page }}</a>
        <a *ngIf="type === 'prev'" [style.color]="'black'">&#60;</a>
        <a *ngIf="type === 'next'" [style.color]="'black'">&#62;</a>
      </ng-template>
    </div>
  </nz-card>
  </div>
</nz-spin>